/* eslint-disable */
import Vue from 'vue'
import App from './App.vue'
// import { customConfigs } from './config';
import VueMaterial from 'vue-material'

import router from './router'
import store from './store/store'
//import customConfigs from '../static/config'
import axios from 'axios'
// import * as firebase from 'firebase'
import 'vue-material/dist/vue-material.min.css'

import VueSweetalert2 from 'vue-sweetalert2';

import 'vue-multiselect/dist/vue-multiselect.min.css'
//import 'vue-material/dist/theme/default.css'
import AppCSS2 from './assets/app2.scss';
import AppCSS from './assets/app.scss';
import FontRoboto from './assets/font-roboto.scss';
import FontLato from './assets/font/fontLato.css'
import FontKanit from './assets/font/fontKanit.css'
// import FontKanit from './assets/font/fontKanit.css'
// import FontAvenir from './assets/font/fontAvenir.css'
// import FontHelveticaNeue from './assets/font/fontHelveticaNeue.css'
// import FontProximaNova from './assets/font/fontProximaNova.css'

import VueJWT from 'vuejs-jwt'
import Multiselect from 'vue-multiselect'
//import VeeValidate from 'vee-validate';
import Vuelidate from 'vuelidate'

import acl from './acl'

import VueSnackbar from 'vue-snack' 
import 'vue-snack/dist/vue-snack.min.css'

import IdleVue from 'idle-vue'

import moment from 'moment-timezone'
import vClickOutside from "v-click-outside";
// import customConfigs from '../static/config.js'
// moment.tz.setDefault('Asia/Bangkok')
Vue.prototype.$moment = moment

Vue.use(Vuelidate)
Vue.use(VueSnackbar)
Vue.use(VueJWT)
Vue.use(VueMaterial)
Vue.use(Multiselect)
Vue.use(AppCSS2)
Vue.use(AppCSS)
Vue.use(FontRoboto)
Vue.use(FontLato)
Vue.use(VueSweetalert2);
Vue.use(FontKanit)
Vue.use(vClickOutside);

const eventsHub = new Vue()
Vue.use(IdleVue, {
    eventEmitter: eventsHub,
    idleTime: 30000
})


Vue.component('multiselect', Multiselect)

// Vue.use( Acl, { router: router, init: 'any' } )



// var configFirebase = {
//   apiKey: 'AIzaSyAvHqzObklZG7Zu8QFwedv3nPvudlH0Io4',
//   authDomain: 'mktops-c0d6c.firebaseapp.com',
//   databaseURL: 'https://mktops-c0d6c.firebaseio.com',
//   storageBucket: 'mktops-c0d6c.appspot.com',
// };
// firebase.initializeApp(configFirebase);

/*axios.defaults.baseURL = 'https://vue-update.firebaseio.com'
// axios.defaults.headers.common['Authorization'] = 'fasfdsa'
axios.defaults.headers.get['Accepts'] = 'application/json'

const reqInterceptor = axios.interceptors.request.use(config => {
  console.log('Request Interceptor', config)
  return config
})
const resInterceptor = axios.interceptors.response.use(res => {
  console.log('Response Interceptor', res)
  return res
})


axios.interceptors.request.eject(reqInterceptor)
axios.interceptors.response.eject(resInterceptor)*/
Vue.config.productionTip = false


Object.keys(process.env).forEach(function (key) {
  Vue.config[key] = process.env[key];
});

// axios.defaults.baseURL = Vue.config['url']
axios.defaults.baseURL = process.env.VUE_APP_API_URL;
Vue.config['url'] = process.env.VUE_APP_API_URL;

//console.log('from main',Vue.config['url'])

//let app;
// Object.keys(config).forEach(function(key) {
//   Vue.config[key] = config[key];
// });

// Object.keys(customConfigs).forEach(function (key) {
//   Vue.configs[key] = customConfigs[key];
// });


/*
firebase.auth().onAuthStateChanged(()=>{
  if(!app) {
    new Vue({
      el: '#app',
      router,
      store,
      render: h => h(App)
    })
  }
})*/

// import Router from '../routes/router'


new Vue({
  el: '#app',
  router,
  store,
  acl,
  render: h => h(App)
})


